import { render, staticRenderFns } from "./formgroup.vue?vue&type=template&id=e5bb58e4&scoped=true"
import script from "./formgroup.js?vue&type=script&lang=js&external"
export * from "./formgroup.js?vue&type=script&lang=js&external"
import style0 from "./formgroup.vue?vue&type=style&index=0&id=e5bb58e4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bb58e4",
  null
  
)

export default component.exports